import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"

const pilotageRoutes: RouteRecordRaw[] = [
  {
    path: "/ma-visibilite/nouvel-etablissement",
    name: "pilotage-empty-state",
    component: () => import("@/views/pilotage/PilotageEmptyState.vue"),
    meta: {
      middleware: [auth],
      title: "space.pilotage_default.title",
    },
  },
  {
    path: "/pilotage/nouvel-etablissement",
    redirect: { name: "pilotage-empty-state" },
  },
]

export default pilotageRoutes
